import ActionExplainerComponents from 'automation-ui-action-features/actions/ActionExplainerComponents';
export default function hasExplainerForAction(action) {
  return Object.hasOwnProperty.call(ActionExplainerComponents, action.getActionType());
}